import _styled from "styled-components";
import React from 'react';
import * as styles from "../styles/DrawerContent.styles";
export var DrawerContent = function DrawerContent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.scrollableContent
  }, children);
};
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "DrawerContent___StyledDiv",
  componentId: "sc-2el8fb-0"
})(["", ""], function (p) {
  return p.$_css;
});